import { Controller } from "@hotwired/stimulus"

// Turbo Stream から呼び出し元の select に新しい option を追加する。
// data-select-id は当面 #caller-id を指し、その要素の textContent に実際の
// select のセレクタを保持する。追加後は一時要素を DOM から取り除く。
export default class extends Controller {
  connect() {
    const caller = document.querySelector(this.element.dataset.selectId)
    const select = caller && document.querySelector(caller.textContent.trim())

    if (select) {
      select.add(new Option(this.element.dataset.optionLabel, this.element.dataset.optionId, true, true))
      select.dispatchEvent(new Event("change", { bubbles: true }))
    }

    this.element.remove()
  }
}
